














































import {Component, Vue} from 'vue-property-decorator'
import loadingService from './services/loading'
import {default as alertService} from './services/alert'
import AlertStack from './components/AlertStack.vue'
import {routes} from './router'
import ProfileMenu from './components/ProfileMenu.vue'
import authService from './services/auth'
import {RouteConfig} from 'vue-router'
import {asyncFilter} from "@/util/common";
import {mapState} from "vuex";
import {firebaseApp} from "@/plugins/firebase";
@Component({
  components: {
    'alert-stack': AlertStack,
    'profile-menu': ProfileMenu
  },
  computed: mapState("auth", ["user"])
})
export default class App extends Vue {
  loading = false
  routes: RouteConfig[] = []
  currentUser: User | null = null

  drawer = false
  user: any;

  async mounted () {
    loadingService.setLoadingBar(this)
    alertService.setAppContainer(this.$refs.alertStack as AlertStack)

    if(this.user) {
      this.routes = await asyncFilter(
        routes, async r => {
          return r.meta?.drawer && await authService.canNavigate(r.meta?.authority,this.user)
        });
    } else {
      this.$store.dispatch('reset')
      firebaseApp.auth().signOut();
      this.$router.push('/')
    }
  }
}
